import { Checkbox } from "@jugl-web/ui-components/cross-platform";
import { useInvoicesTableContext } from "../../../context/useInvoicesTableContext";

interface ComponentProps {
  id: string;
}

export const CheckboxCell: React.FC<ComponentProps> = ({ id }) => {
  const { selected } = useInvoicesTableContext();

  return (
    <Checkbox
      size="sm"
      isChecked={selected.items.has(id)}
      onChange={() => selected.toggleItem(id)}
    />
  );
};
